import { render, staticRenderFns } from "./editJuisd.vue?vue&type=template&id=d56b26d4&scoped=true"
import script from "./editJuisd.vue?vue&type=script&lang=js"
export * from "./editJuisd.vue?vue&type=script&lang=js"
import style0 from "./editJuisd.vue?vue&type=style&index=0&id=d56b26d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56b26d4",
  null
  
)

export default component.exports